import { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
// component
import DashboardLayoutRoute from "./layouts/dashbord/DashboardLayoutRoute";
const PageNotFound = lazy(() =>
  import("./components/Presentational/PageNotFound")
);
const Login = lazy(() => import("./pages/Login"));
const TosEmailApprovePage = lazy(() =>
  import("./containers/TosEmailApprovePage")
);
const OrderEmailApprovePage = lazy(() =>
  import("./containers/OrderEmailApprove")
);

export default function Routes() {
  return (
    <Router>
      <Suspense fallback={<LoadingFallback />}>
        <Switch>
          <Route path="/not-found" render={() => <PageNotFound />} />
          <Route path="/login" render={() => <Login />} />
          <Route path="/ms-callback" component={MicrosoftIdentityCallback} />
          <Route
            path="/tosEmailApprove"
            render={(props) => <TosEmailApprovePage {...props} />}
          />
          <Route
            path="/orderEmailApprove"
            render={(props) => <OrderEmailApprovePage {...props} />}
          />
          <Route component={DashboardLayoutRoute} />
        </Switch>
      </Suspense>
    </Router>
  );
}

function LoadingFallback() {
  return <p>Loading component....</p>;
}

function MicrosoftIdentityCallback() {
  return <Redirect to="/" />;
}
